const ActionTypes = {
   SET_PRODUCTS:'SET_PRODUCTS',
   ADD_PRODUCT:'ADD_PRODUCT',
   REMOVE_PRODUCT:'REMOVE_PRODUCT',
   FETCH_PRODUCTS:'FETCH_PRODUCTS',
   FETCH_PRODUCT:'FETCH_PRODUCT'
}

export default ActionTypes;